import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Button } from 'antd';

import Base from '../Base';

function download(url) {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export class PhysicalLocationExporter extends Base {
  constructor(props) {
    super(props);

    this.state = {};
    this.exportToExcel = this.exportToExcel.bind(this);
    this.exportList = this.exportList.bind(this);
    this.exportStructure = this.exportStructure.bind(this);
    this.download = download.bind(this);
    this.getTransactionStatus = this.getTransactionStatus.bind(this);
  }

  async exportToExcel() {
    const { t, view } = this.props;

    const exportFn = view === 'list' ? this.exportList : this.exportStructure;

    try {
      this.loading(true);
      this.clearNotification();
      this.showMessage(t('exportPhysicalLocationInfo'));

      const response = await exportFn();

      this.getTransactionStatus(response.data.transactionId);
    } catch (err) {
      console.error(err);
      if (err.status !== 401) {
        super.handleError(t('fetchError'));
      } else {
        this.loading(false);
        this.hideMessage(false);
      }
    }
  }

  async exportList() {
    const {
      exportList, filter, sort
    } = this.props;

    return super.dispatchWithAuth(exportList, filter, sort);
  }

  async exportStructure() {
    const {
      exportStructure, filter, companyUuid, parentUuid
    } = this.props;

    // Not required for structure export
    delete filter['filter.companies'];

    return super.dispatchWithAuth(exportStructure, filter, companyUuid, parentUuid);
  }

  async getTransactionStatus(transactionId) {
    const { t, getExportTransactionStatus } = this.props;
    try {
      const response = await super.dispatchWithAuth(getExportTransactionStatus, transactionId);
      if (response.data.attributes.status === 'FINISHED') {
        this.download(response.data.attributes.extraDetail.downloadUrl);
        this.loading(false);
        this.hideMessage(false);
      } else if (response.data.attributes.status === 'UNEXPECTED_ERROR') {
        super.handleError(t('fetchError'));
        this.loading(false);
      } else {
        setTimeout(() => {
          this.getTransactionStatus(transactionId);
        }, 500);
      }
    } catch (err) {
      if (err.status !== 401) {
        super.handleError(t('fetchError'));
      } else {
        this.loading(false);
        this.hideMessage(false);
      }
    }
  }

  loading(state) {
    this.setState({ loading: state });
  }

  render() {
    const { style, text, disabledButton } = this.props;
    const { loading } = this.state;
    return (
      <>
        <Button
          icon="download"
          loading={loading}
          onClick={this.exportToExcel}
          style={style}
          disabled={disabledButton}
        >
          {text}
        </Button>
      </>
    );
  }
}

PhysicalLocationExporter.defaultProps = {
  filter: {},
  sort: {},
};

PhysicalLocationExporter.propTypes = {
  t: PropTypes.func.isRequired,
  filter: PropTypes.object,
  sort: PropTypes.object,
  view: PropTypes.string.isRequired,
  disabledButton: PropTypes.bool.isRequired,
  exportList: PropTypes.func.isRequired,
  exportStructure: PropTypes.func.isRequired,
};

export default withTranslation(['physicalLocations', 'common'])(PhysicalLocationExporter);
